import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity, ClientEntity, TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FeatureTaxReportDetailsComponent } from '../../tax-report-details/feature-tax-report-details.component';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-toelichting-leningen-bestuurders-commissarissen',
  templateUrl: './toelichting-leningen-bestuurders-commissarissen.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./toelichting-leningen-bestuurders-commissarissen.component.css']
})
export class ToelichtingLeningenBestuurdersCommissarissenComponent implements OnInit, OnChanges, OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosureFg = {} as FormGroup;
  public loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescriptionFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const tekstueel = value.rapportage?.jaarrekeningen?.at(0)?.toelichting.overigeToelichtingen?.leningenBestuurdersCommissarissen?.leningenVoorschottenGarantiesBestuurdersCommissarissenTekstueel;
    if (tekstueel) {
      if (tekstueel.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosure) {
        this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosureFg.patchValue(tekstueel.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosure);
      }
      if (tekstueel.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescription) {
        this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescriptionFg.patchValue(tekstueel.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescription);
      }
     }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });

    this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescriptionFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        toelichting: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting,
          overigeToelichtingen: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.overigeToelichtingen,
            leningenBestuurdersCommissarissen: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0].toelichting?.overigeToelichtingen?.leningenBestuurdersCommissarissen,
              leningenVoorschottenGarantiesBestuurdersCommissarissenTekstueel: {
                ...this.jrEntity.rapportage?.jaarrekeningen[0].toelichting?.overigeToelichtingen?.leningenBestuurdersCommissarissen?.leningenVoorschottenGarantiesBestuurdersCommissarissenTekstueel,
                loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosure: this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosureFg.value,
                loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescription: this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescriptionFg.value,
              }
            },
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
  }
}
